import React from 'react'
import "./myTable.css"

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

//   function createData(name, calories, fat, carbs, protein) {
//     return { name, calories, fat, carbs, protein };
//   }
  
//   const rows = [
//     createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
//     createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
//     createData('Eclair', 262, 16.0, 24, 6.0),
//     createData('Cupcake', 305, 3.7, 67, 4.3),
//     createData('Gingerbread', 356, 16.0, 49, 3.9),
//   ];

const getLvl = (lvl)=>{
  if(lvl === "E"){
    return <span className='e-lvl'>Easy</span>
  }
  if(lvl === "M"){
    return <span className='m-lvl'>Medium</span>
  }
  if(lvl === "H"){
    return <span className='h-lvl'>Hard</span>
  }
  return <span className='na-lvl'>NA</span>
}

function MyTable({rows}) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 350 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Problem Name</StyledTableCell>
            <StyledTableCell align="right">Link&nbsp;(External)</StyledTableCell>
            <StyledTableCell align="right">Video&nbsp;(External)</StyledTableCell>
            <StyledTableCell align="right">Difficulty</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <StyledTableRow key={row?.title}>
              <StyledTableCell component="th" scope="row">
                {row?.title}
              </StyledTableCell>
              <StyledTableCell align="right">{
                <Link className='probLink' to={row?.probLink} target='_blank' >
                <span class="material-symbols-outlined">
assistant_direction
</span>
                </Link>
              }</StyledTableCell>
              <StyledTableCell align="right">{
                <Link className='vidLink' to={row?.vidLink} target='_blank' >
                <span class="material-symbols-outlined">
                            videocam
                        </span>
                </Link>
              }</StyledTableCell>
              <StyledTableCell align="right">{
                getLvl(row?.lvl)
              }</StyledTableCell>
              
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default MyTable